import { motion, AnimatePresence } from "framer-motion";
import { Square } from "lucide-react";
import { useAudio } from "@/components/audio-provider";

export function NowPlayingBar() {
  const { nowPlaying, nowPlayingProgress, stop } = useAudio();

  return (
    <AnimatePresence>
      {nowPlaying && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.18, ease: "easeInOut" }}
          className="flex items-center gap-1.5 rounded-full border border-spark/20 bg-spark/5 px-1.5 py-1 backdrop-blur-sm sm:gap-2.5 sm:px-3"
        >
          <img src="/brand/face.png" alt="" className="h-4 w-4 shrink-0 rounded-full object-cover sm:h-6 sm:w-6" />

          <div className="hidden h-4 w-4 shrink-0 items-center justify-center sm:flex">
            <span className="flex gap-[2px]">
              {[0, 1, 2].map((i) => (
                <motion.span
                  key={i}
                  className="inline-block w-[2px] rounded-full bg-spark"
                  animate={{ height: ["4px", "10px", "4px"] }}
                  transition={{
                    duration: 0.6,
                    repeat: Infinity,
                    delay: i * 0.15,
                    ease: "easeInOut",
                  }}
                />
              ))}
            </span>
          </div>

          <span className="max-w-[72px] truncate font-display text-[11px] font-semibold tracking-display text-parchment sm:max-w-[180px] sm:text-sm">
            {nowPlaying.title}
          </span>

          <div className="hidden h-1 w-12 overflow-hidden rounded-full bg-mist sm:block sm:w-20">
            <motion.div
              className="h-full rounded-full bg-spark"
              style={{ width: `${nowPlayingProgress * 100}%` }}
              transition={{ duration: 0.1 }}
            />
          </div>

          <button
            onClick={() => stop(nowPlaying.id)}
            className="shrink-0 rounded-full p-1 text-fog transition-colors hover:bg-spark/15 hover:text-parchment"
          >
            <Square className="h-3 w-3" />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
